//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/TransientObject.js";
let d=[[[0,"NumCols",0,0],[0,"NumRows",0,0]],[[["nRows","nCols","dDefaultValue"],"SetTableSize",{},3,0],[["nRows","dDefaultValue"],"SetNumberOfRows",{},2,0],[["iRow","iCol"],"GetCellValue",{R_:{cellValue:''}},2,0],[["iRow","iCol","cellValue"],"SetCellValue",{},3,0],[["iRow","iCol","cellValue"],"SetCellValue1",{},3,0],[["iRow","iCol"],"SetCellNoValue",{},2,0],[["iRow","rowValues"],"SetNthRow",{},2,0],[["iRow","n_size"],"GetNthRow",{R_:{rowValues:""}},1,0],[["iCol","columnValues"],"SetNthColumn",{},2,0],[["iCol","n_size"],"GetNthColumn",{R_:{columnValues:""}},1,0],[["iCol","unit_type"],"SetNthColumnUnits",{},2,0],[["iCol"],"GetNthColumnUnits",{R_:{unit_type:"Unit"}},1,0],[[],"Dispose",{},0,0]],[]];
SPLM.GeneralScalarTable = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.GeneralScalarTable";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;